import React from 'react';

const LinkedInShareButton = ({ url, title, summary, source }) => {
  const handleClick = () => {
    const shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(summary)}&source=${encodeURIComponent(source)}`;
    window.open(shareUrl, '_blank', 'width=600,height=400');
  };

  return (
    <button onClick={handleClick}>
      <img
        src={process.env.NEXT_PUBLIC_WEPRODIGI + '/uploads/images/blog/ln.svg'} width={25}
        height={25} alt="share linkedin" />
    </button>
  );
};

export default LinkedInShareButton;
